<template>
  <div>
    <SidebarLayout2
      :breadcrumb="breadcrumb"
      pageTitle="Produtos e Serviços da Rede"
    >
      <template #sidebar>
        <SidebarBlock class="sidebar-actions">
          <PmwParagraph size="paragraph-80" weight="medium">
            Ações da página
          </PmwParagraph>
          <PmwButton
            link="/produtos-e-servicos/criar-produto/"
            variation="blue-100"
            element="router-link"
            hasIcon
          >
            Criar Produto da Rede
          </PmwButton>
          <PmwButton
            :disabled="selectedRows.length !== 1"
            :link="
              `/produtos-e-servicos/editar-produto/${
                selectedRows[0]?.codigo
              }/${removeStringAccents(selectedRows[0]?.tipo.toLowerCase())}`
            "
            element="router-link"
            variation="blue-100"
            target="_blank"
          >
            Editar
          </PmwButton>
          <PmwButton
            :disabled="
              selectedRows.length < 1 ||
                !selectedRows.every((item) => item.ativo === 'Ativo')
            "
            variation="red-100"
            @click="disableModal()"
          >
            Desativar
          </PmwButton>
          <PmwButton
            :disabled="
              selectedRows.length < 1 ||
                !selectedRows.every((item) => item.ativo === 'Inativo')
            "
            variation="blue-100"
            @click="reactivateModal()"
          >
            Reativar
          </PmwButton>
        </SidebarBlock>
      </template>

      <template #page-description>
        <PmwParagraph size="paragraph-40">
          Produtos e serviços que são compartilhados em mais de 1 hotel da sua
          rede.
        </PmwParagraph>
      </template>

      <template #content>
        <div class="filters">
          <div class="filters-row">
            <!-- NOME -->
            <SearchInput
              v-model="nameInput"
              placeholder="Buscar por nome"
              class="filters--input"
            />
          </div>

          <!-- HOTEL -->
          <PmwFilterDropdown
            v-model="selectedHotel"
            :options="hotelOptions"
            :radioOptions="false"
            label="Hotéis"
            class="filters--dropdown"
            hasSearch
          />

          <!-- GRUPO DE HOTÉIS -->
          <PmwFilterDropdown
            v-model="selectedGrouperHotel"
            :options="grouperHotelsOptions"
            :radioOptions="false"
            label="Grupos de hotéis"
            class="filters--dropdown"
            hasSearch
          />

          <!-- STATUS -->
          <PmwFilterDropdown
            v-model="selectedStatus"
            :options="statusOptions"
            label="Status"
            radioOptions
          />

          <!-- TIPO -->
          <PmwFilterDropdown
            v-model="selectedType"
            :options="typeOptions"
            label="Tipo"
            radioOptions
          />

          <!-- CONDIÇÃO -->
          <PmwFilterDropdown
            v-model="selectedCondition"
            :options="conditionOptions"
            label="Condição"
            radioOptions
          />
        </div>

        <DataTable
          :cols="cols"
          :rows="rows"
          :isLoading="isLoading"
          :colsMinWidths="colsMinWidths"
          ref="dataTable"
          maxHeight="none"
          class="datatable"
          selectableRow
          selectedRowHasBgColor
          @getSelectedRows="selectedRows = $event"
        >
          <template #acoes="{rowDataObj}">
            <PmwDropdown strategy="absolute" class="datatable-dropdown">
              <template #button-content>
                <Icon icon="dots" class="datatable-dropdown--icon" />
              </template>
              <template #default>
                <PmwDropdownItem
                  :to="
                    `/admin/v2/produtos-e-servicos/editar-produto/${
                      rowDataObj.codigo
                    }/${removeStringAccents(rowDataObj.tipo.toLowerCase())}`
                  "
                  :key="`product-edition-${rowDataObj.codigo}`"
                  class="datatable-dropdown--link"
                  target="_blank"
                  element="a"
                >
                  Editar
                </PmwDropdownItem>
                <PmwDropdownItem
                  v-if="rowDataObj.ativo === 'Ativo'"
                  :key="`product-disable-${rowDataObj.codigo}`"
                  element="button"
                  class="datatable-dropdown--action__disable"
                  @click="disableModal(rowDataObj.codigo)"
                >
                  Desativar
                </PmwDropdownItem>
                <PmwDropdownItem
                  v-else
                  element="button"
                  @click="reactivateModal(rowDataObj.codigo)"
                >
                  Reativar
                </PmwDropdownItem>
              </template>
            </PmwDropdown>
          </template>
        </DataTable>

        <PmwPagination
          v-show="pagination.totalItems > 25"
          :itemsPerPage="pagination.itemsPerPage"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          :items="pagination.items"
          :currentPage="pagination.currentPage"
          :totalItems="pagination.totalItems"
          @changePagination="changePagination"
        />
      </template>
    </SidebarLayout2>

    <!-- MODAL DESATIVAR -->
    <PmwAlertModal
      v-model="showDisableModal"
      cancelButtonColor="grey-90"
      confirmButtonColor="error-80"
      confirmButtonText="Sim, quero desativar"
      icon="pmw-trash-can"
      iconColor="error-80"
      title="Desativar"
      closeButton
      @alert-modal-confirm="disableProducts"
      @alert-modal-cancel="singleRow = []"
    >
      <template #text>
        Ao desativar esse produto ele não <br />
        estará mais disponível para venda.<br />
        Você tem certeza que quer fazer isso?
      </template>
    </PmwAlertModal>

    <!-- MODAL REATIVAR -->
    <PmwAlertModal
      v-model="showReactivateModal"
      cancelButtonColor="blue-100"
      confirmButtonColor="blue-100"
      confirmButtonText="Sim, quero reativar"
      closeButton
      @alert-modal-confirm="reactivateProducts"
      @alert-modal-cancel="singleRow = []"
    >
      <template #text>
        Ao reativar esse produto ele estará disponível para venda.<br />
        Você tem certeza que quer fazer isso?
      </template>
    </PmwAlertModal>
  </div>
</template>

<script>
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwDropdown from '@solucoes/components-lib-tmp/src/components/patterns/PmwDropdown'
import PmwDropdownItem from '@solucoes/components-lib-tmp/src/components/patterns/PmwDropdown/PmwDropdownItem'
import PmwFilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/PmwFilterDropdown'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import { removeStringAccents } from '@/helpers/string'

export default {
  name: 'ProductsAndServices',

  components: {
    SidebarLayout2,
    DataTable,
    PmwAlertModal,
    PmwButton,
    PmwDropdown,
    PmwDropdownItem,
    PmwFilterDropdown,
    PmwPagination,
    PmwParagraph,
    SearchInput,
    SidebarBlock
  },

  data() {
    return {
      breadcrumb: [
        {
          label: 'Produtos e Serviços da Rede',
          url: ''
        }
      ],

      hotelOptions: [],

      selectedHotel: [],

      selectedGrouperHotel: [],

      grouperHotelsOptions: [],

      nameInput: '',

      statusOptions: [
        { value: null, label: 'Todos' },
        { value: true, label: 'Ativo', checked: true },
        { value: false, label: 'Inativo' }
      ],

      selectedStatus: {},

      typeOptions: [
        { value: null, label: 'Todos', checked: true },
        { value: 2, label: this.setType(2) },
        { value: 3, label: this.setType(3) },
        { value: 4, label: this.setType(4) }
      ],

      selectedType: {},

      conditionOptions: [
        { value: null, label: 'Todos', checked: true },
        { value: 1, label: this.setCondition(1) },
        { value: 2, label: this.setCondition(2) },
        { value: 3, label: this.setCondition(3) }
      ],

      selectedCondition: {},

      cols: [
        { name: 'tipo', alias: 'Tipo' },
        { name: 'nome', alias: 'Nome' },
        { name: 'descricao', alias: 'Agrupador ou Descrição' },
        { name: 'ativo', alias: 'Status' },
        { name: 'condicaoHospedagem', alias: 'Condição' },
        { name: 'acoes', alias: 'Ações' }
      ],

      colsMinWidths: {
        tipo: '100px',
        nome: '200px',
        ativo: '78px',
        descricao: '280px',
        acoes: '64px'
      },

      rows: [],

      isLoading: false,

      pagination: {
        itemsPerPage: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '100',
            value: 100
          }
        ],
        items: [],
        currentPage: 1,
        totalItems: 0
      },

      selectedRows: [],

      showDisableModal: false,

      showReactivateModal: false,

      /** Armazena o código da linha única que deve ser selecionada  */
      singleRow: null
    }
  },

  computed: {
    /** Retorna um objeto com os valores dos itens selecionados nos filtros */
    filterValues() {
      let hotels = this.selectedHotel.length
        ? this.selectedHotel.map((item) => item.value)
        : []

      if (this.selectedGrouperHotel?.length) {
        const grouperHotelsIds = this.selectedGrouperHotel.flatMap((item) =>
          item.hoteis.map((hotel) => hotel.codigo)
        )

        hotels = [...hotels, ...grouperHotelsIds]
      }

      const filter = {
        nome: this.nameInput,
        status: this.selectedStatus.value ?? null,
        tipo: this.selectedType.value,
        condicaoHospedagem: this.selectedCondition.value,
        hoteisProdutoMaster: hotels.length ? hotels : null
      }

      if (!filter.hoteisProdutoMaster) delete filter.hoteisProdutoMaster

      return filter
    }
  },

  async created() {
    this.isLoading = true

    await this.getHotels()
    await this.getGrouperHotels()
    await this.getProducts()
  },

  watch: {
    /**
     * Recarrega a tabela conforme alterações nos filtros
     * @param {object} newVal: filtros utilizados
     */
    filterValues(newVal, oldVal) {
      /** Verificar se houveram mudanças nos filtros  por ID de hotel e status */
      if (
        newVal &&
        (newVal.hoteisProdutoMaster !== oldVal.hoteisProdutoMaster ||
          newVal.status !== oldVal.status)
      ) {
        return this.getProducts()
      }

      this.standarizeTableData()
    }
  },

  methods: {
    /**
     * Busca a lista de produtos
     * @param {object} filters: filtros utilizados
     */
    getProducts(filters = this.filterValues) {
      this.isLoading = true

      this.$productsAndServicesMaster
        .getProducts(filters)
        .then((response) => {
          this.productsList = response.data

          this.standarizeTableData()
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages[0]
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    /** Padroniza os dados para exibir na tabela */
    standarizeTableData() {
      const filter = this.filterValues

      /** Filtrar valores dos produtos */
      const filteredData = this.productsList?.filter((product) => {
        return (
          product.nome.toLowerCase().indexOf(filter.nome.toLowerCase()) > -1 &&
          (filter.status === null || product.ativo === filter.status) &&
          (filter.tipo === null || product.tipo === filter.tipo) &&
          (filter.condicaoHospedagem === null ||
            product.condicaoHospedagem === filter.condicaoHospedagem)
        )
      })

      /** Formatar e paginar os dados */
      this.pagination.items = filteredData?.map((item) => {
        return {
          data: {
            codigo: item.codigo,
            tipo: this.setType(item.tipo),
            nome: item.nome,
            descricao: item.descricao,
            ativo: item.ativo ? 'Ativo' : 'Inativo',
            condicaoHospedagem: this.setCondition(item.condicaoHospedagem),
            possuiCalendarioDisponibilidade:
              item.possuiCalendarioDisponibilidade,
            possuiCalendarioTarifaBase: item.possuiCalendarioTarifaBase
          }
        }
      })

      this.pagination.totalItems = filteredData?.length ?? 0

      this.rows = this.pagination.items
    },

    /**
     * Maneja a exibição dos dados conforme a paginação
     * @param {object} paginationData: dados da paginação
     * @param {array} paginationData.items: itens que serão exibidos
     * @param {number} paginationData.currentPage: número da página atual
     */
    changePagination(paginationData) {
      this.rows = paginationData.items
      this.pagination.currentPage = paginationData.currentPage
    },

    /**
     * Seta o tipo de produto conform o ID informado
     * @param {number} id: id do tipo de produto
     */
    setType(id) {
      const productTypes = {
        2: 'Transfer',
        3: 'Agendável',
        4: 'Avulso'
      }

      return productTypes[id]
    },

    /**
     * Seta a condição do produto conform o ID informado
     * @param {number} id: id da condição do produto
     */
    setCondition(id) {
      const productConditions = {
        1: 'Precisa de hospedagem',
        2: 'Não precisa hospedagem',
        3: 'Não aceita hospedagem'
      }

      return productConditions[id]
    },

    /** Busca a lista de hotéis para o filtro */
    getHotels() {
      this.$initialSetting.getHotels({ ativo: true }).then((response) => {
        const data = response.data

        this.hotelOptions = data.map((item) => {
          return {
            value: item.codigo,
            label: item.nome
          }
        })
      })
    },

    /** Buscar Grupos de Hotéis para o filtro */
    getGrouperHotels() {
      this.$hotel
        .getHotelBundlers()
        .then((response) => {
          const groupers = response.data?.filter((grouper) => grouper.ativo)

          this.grouperHotelsOptions = groupers.map((grouper) => {
            return {
              label: grouper.nome,
              value: grouper.codigo,
              hoteis: grouper.hoteis
            }
          })
        })
        .catch(function() {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar os grupos de hotéis.'
          })
        })
    },

    /**
     * Exibe a modal de deleção e cria um array com os ids
     * @param {number} id: ID do produto, quando a modal for aberta a partir da linha da tabela
     */
    disableModal(id) {
      this.singleRow = id

      this.showDisableModal = true
    },

    /** Desativa os produtos selecionados */
    disableProducts() {
      const codigos = this.singleRow
        ? [this.singleRow]
        : this.selectedRows.map((item) => item.codigo)

      this.$productsAndServicesMaster
        .disableProducts(codigos)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message:
              'Estamos salvando suas alterações, avisaremos assim que terminar.'
          })

          this.getProducts()
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages[0]
          })
        })
        .finally(() => {
          this.$refs.dataTable.selectAllRows()
          this.singleRow = null
          this.selectedRows = []
        })
    },

    /**
     * Exibe a modal de reativação e cria um array com os ids
     * @param {number} id: ID do produto, quando a modal for aberta a partir da linha da tabela
     */
    reactivateModal(id) {
      this.singleRow = id

      this.showReactivateModal = true
    },

    /** Reativa os produtos selecionados */
    reactivateProducts() {
      const codigos = this.singleRow
        ? [this.singleRow]
        : this.selectedRows.map((item) => item.codigo)

      this.$productsAndServicesMaster
        .reactivateProducts(codigos)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message:
              'Estamos salvando suas alterações, avisaremos assim que terminar.'
          })

          this.getProducts()
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages[0]
          })
        })
        .finally(() => {
          this.$refs.dataTable.selectAllRows()
          this.singleRow = null
          this.selectedRows = []
        })
    },

    removeStringAccents
  }
}
</script>

<style lang="scss" scoped>
.sidebar-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters {
  &-row {
    display: flex;
    gap: 30px;
    margin-bottom: 25px;
  }

  &--input {
    width: 215px;
  }

  &--dropdown {
    & ::v-deep .pmw-dropdown--options {
      width: max-content;
    }
  }
}

.datatable {
  margin-top: 32px;
  overflow: visible;

  &-dropdown {
    &--icon {
      rotate: 90deg;
      width: 16px;
      height: 16px;
    }

    &--link {
      color: pmw-colors('grey-90') !important;
    }

    &--action {
      &__disable {
        color: pmw-colors('red-100');
      }
    }
  }
}

::v-deep .pmw-datatable-wrapper__overflow {
  .pmw-tr-wrapper.pmw-datatable--row__selected-color {
    color: $pmw-white;
  }

  .pmw-col.pmw-th:last-child {
    max-width: 64px;
    pointer-events: none;
    .pmw-sort-icons {
      display: none;
    }
  }
  .pmw-col.pmw-td:last-child {
    max-width: 64px;
    justify-content: center;
  }
}

::v-deep .lb-breadcrumb--link {
  &:nth-child(2) {
    cursor: default;
    pointer-events: none;
  }
}

::v-deep .pmw-filter-dropdown {
  max-width: 250px;

  &--options {
    padding: 15px;
  }

  .pmw-dropdown--trigger-button {
    background-color: $pmw-white;
    gap: 7px;

    &:active,
    &[aria-expanded='true'] {
      color: pmw-colors('grey-90');
      background-color: $pmw-white;
    }
  }
}

::v-deep .pmw-input-radio {
  input {
    &:checked ~ .pmw-input-radio--fake-radio {
      border-color: pmw-colors('blue-100');

      &:before {
        background-color: pmw-colors('blue-100');
      }
    }
  }
}
</style>
